var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "12px",
    height: "12px",
    viewBox: "-6.5 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.436.006c.051-.004.111-.007.172-.007 1.237 0 2.239 1.003 2.239 2.239 0 .041-.001.081-.003.122v-.006c-.079 1.679-1.46 3.01-3.151 3.01-.022 0-.043 0-.065-.001h.003c-.069.008-.15.012-.231.012-1.188 0-2.151-.963-2.151-2.151 0-.088.005-.174.015-.259l-.001.01c.063-1.655 1.419-2.972 3.084-2.972.031 0 .062 0 .093.001h-.005zm-4.947 23.994c-1.268 0-2.199-.783-1.311-4.226l1.456-6.108c.254-.978.295-1.369 0-1.369-1.141.293-2.142.752-3.035 1.359l.033-.021-.633-1.057c3.086-2.622 6.638-4.159 8.158-4.159 1.268 0 1.48 1.526.845 3.874l-1.666 6.421c-.296 1.135-.168 1.526.126 1.526 1.106-.256 2.069-.761 2.863-1.456l-.008.007.72.979c-3.004 3.052-6.281 4.232-7.549 4.232z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSvgrepoCom);
export default __webpack_public_path__ + "static/media/info-svgrepo-com.dae1fb603cc467ab01a2a0933972c924.svg";
export { ForwardRef as ReactComponent };